<template>
  <div class="profile-page">
    <profile-cover @cover-change="coverChange"/>
    <div class="text-wrapper">
      <div class="col">
        <h2>„Nur wenn unsere Kundinnen und Kunden erfolgreich sind, sind wir es auch.“</h2>
        <p>Dr. Susanna Zapreva <br>Vorstandsvorsitzende der enercity AG</p>
      </div>
      <div class="col">
        <p>Nicht nur in Hannover und der Region, sondern deutschland&shy;weit leistet enercity inzwischen einen wichtigen Beitrag zum Gelingen der Energiewende. Ob mit Wind- oder Solarenergie, mit klimaneutral erzeugter Wärme aus Biomasse, Biogas oder industrieller Abwärme oder durch die Förderung der E-Mobilität: Unsere intelligenten Energielösungen von morgen schonen bereits heute Klima und Ressourcen.</p>
        <p>Auf dem Weg in die klimafreundliche, digitale Energiewelt der Zukunft setzt enercity auf die Werte Kundenorientierung, Innovation, Verlässlichkeit und Nachhaltigkeit.</p>
        <p>Wir richten all unsere Aktivitäten an den Bedürfnissen unserer Kundinnen und Kunden aus: Denn nur wenn sie zufrieden und erfolgreich sind, sind wir es auch.</p>
      </div>
    </div>
    <profile-facts/>
    <profile-solutions/>
    <profile-activities/>
    <page-footer @scroll-to-top="toTop"/>
  </div>
</template>

<script>
  import ProfileCover from "../elements/ProfileCover";
  import ProfileFacts from "../elements/ProfileFacts";
  import ProfileSolutions from "../elements/ProfileSolutions";
  import ProfileActivities from "../elements/ProfileActivities";
  import PageFooter from "@/components/PageFooter";
  export default {
    name: "PageProfile",
    components: {PageFooter, ProfileActivities, ProfileSolutions, ProfileFacts, ProfileCover},
    data() {
      return {}
    },
    methods: {
      toTop() {
        this.$emit('scroll-to-top');
      },
      coverChange(data) {
        this.$emit('cover-change', data);
      }
    },
    emits: ['change-content', 'scroll-to-top', 'cover-change'],
    mounted() {
      this.$emit('change-content', {showContent: true, title: 'Profil & Vision'});
    }
  }
</script>

<style scoped>
  .text-wrapper {
    width: 1020px;
    max-width: calc(100% - 120px);
    margin: 0 auto;
    font-weight: 400;
    line-height: 1.6;
    display: flex;
  }
  .col {
    flex: 1 1 50%;
    max-width: 50%;
    padding: 0 25px;
  }
  .col:first-child * {
    text-align: right;
    background: linear-gradient(90deg, #B1D995 0%, #3CB2B8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-left: 0;
  }
  .profile-page {
    min-height: 100vh;
    background-color: white;
  }
  h2 {
    margin: 0.1em 0 0.7em;
    font-size: 48px;
  }
  @media(max-width: 999px) {
    .text-wrapper {
      padding: 0 34px;
      display: block;
      margin: -30px auto calc(40px + 5%);
      max-width: 100%;
    }
    .col {
      max-width: none;
      padding: 0;
    }
    .col:first-child {
      margin-bottom: calc(20px + 3%);
    }
    .col:first-child * {
      text-align: center;
    }
    h2 {
      margin-bottom: 0.2em;
    }
  }
  @media(max-width: 767px) {
    .text-wrapper {
      padding: 0 20px;
      margin-top: calc(20px + 5%);
    }
    h2 {
      font-size: 32px;
    }
  }
</style>